import { computed, ref } from 'vue'
import { games, isGameVisible } from '@/data/games'
import { getAllowedGameIds } from '@/api/session'
import { getBetPath } from '@/composables/betRoute'

const KEY = 'active-game-id'
const DEFAULT_ID = 14

const readStored = () => {
  try {
    const n = Number(localStorage.getItem(KEY))
    return n > 0 ? n : DEFAULT_ID
  } catch {
    return DEFAULT_ID
  }
}

const gameId = ref(readStored())

function firstVisibleId (preferId) {
  const prefer = Number(preferId)
  const list = games.value || []
  const allowed = getAllowedGameIds()
  const candidates = list.filter((g) => g && isGameVisible(g))
  if (prefer > 0 && candidates.some((g) => Number(g.id) === prefer)) {
    return prefer
  }
  if (allowed?.length) {
    for (const id of allowed) {
      if (candidates.some((g) => Number(g.id) === Number(id))) return Number(id)
    }
  }
  const def = candidates.find((g) => Number(g.id) === DEFAULT_ID)
  return Number(def?.id || candidates[0]?.id || DEFAULT_ID)
}

export function setActiveGame (id) {
  const next = firstVisibleId(id)
  if (gameId.value !== next) {
    gameId.value = next
    try {
      localStorage.setItem(KEY, String(next))
    } catch {
      /* ignore */
    }
  }
  return gameId.value
}

/** SSO / 控彩范围变更后：纠正当前激活彩种（避免还停在快乐8等） */
export function reconcileActiveGame (preferId) {
  return setActiveGame(preferId || gameId.value)
}

export function syncGameFromQuery (queryId) {
  const n = Number(queryId)
  if (n > 0) setActiveGame(n)
  else reconcileActiveGame()
  return gameId.value
}

export function ensureGameQuery (route, router) {
  const qid = Number(route.query.id)
  const id = syncGameFromQuery(qid > 0 ? qid : undefined)
  const dedicated = getBetPath(id)
  // 停在通用 /bet 但目标是专用页（双色球/大乐透/3D…）时强制改道
  if (
    route.path.startsWith('/bet') &&
    dedicated !== '/bet' &&
    route.path !== dedicated
  ) {
    router.replace({ path: dedicated, query: { ...route.query, id } })
    return id
  }
  if (Number(route.query.id) !== id) {
    router.replace({
      path: route.path.startsWith('/bet') ? dedicated : route.path,
      query: { ...route.query, id }
    })
  }
  return id
}

export function useActiveGame () {
  const currentGame = computed(() => {
    const id = gameId.value
    const list = games.value || []
    return (
      list.find((g) => Number(g.id) === Number(id) && isGameVisible(g)) ||
      list.find((g) => Number(g.id) === firstVisibleId(id)) ||
      list[0]
    )
  })

  return {
    gameId,
    currentGame,
    setActiveGame,
    reconcileActiveGame,
    syncGameFromQuery,
    ensureGameQuery
  }
}
